import { render, staticRenderFns } from "./cookieBanner.app.vue?vue&type=template&id=2d981aa6&scoped=true"
import script from "./cookieBanner.app.vue?vue&type=script&lang=ts"
export * from "./cookieBanner.app.vue?vue&type=script&lang=ts"
import style0 from "./cookieBanner.app.vue?vue&type=style&index=0&id=2d981aa6&prod&scoped=true&lang=css"
import style1 from "@/components/common/modern/modern.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d981aa6",
  null
  
)

export default component.exports